import React, {useEffect, useState} from 'react';
import {Button, Skeleton, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import PayoutForm from "src/components/PayoutForm";
import appointmentApi from "src/api/project/appointment";
import nextPaymentDateApi from "src/api/miscelleneous/nextPaymentDateApi";
import Box from "@mui/material/Box";
import UpcomingAppointmentsList from "src/components/UpcomingAppointmentsList";
import {formatPrice} from "src/functions/priceFormatter";
import {apiDateTimeStringToDate, dateToApiDateString} from "src/api/apiDateTimeHandler";
import {format} from "date-fns";
import useAuth from "src/hooks/use-auth";

const DashboardPage = () => {
  const [upcomingAppointments, setUpcomingAppointments] = useState(null);
  const [nextPaymentDate, setNextPaymentDate] = useState(null);
  const { myUser, refreshMyUser } = useAuth();

  const fetchUpcomingAppointments = async () => {
    const fetchedUpcomingAppointments = await appointmentApi.retrieveCollection({
      'projectInstance.start[after]': dateToApiDateString(new Date()),
    });
    setUpcomingAppointments(fetchedUpcomingAppointments['hydra:member']);
  }

  const fetchNextPaymentDate = async () => {
    const fetchedNextPaymentDate = await nextPaymentDateApi.retrieveItem();
    setNextPaymentDate(apiDateTimeStringToDate(fetchedNextPaymentDate.nextPaymentDate));
  }

  const onPayoutSuccess = () => {
    refreshMyUser(); // Refresh the user so accountBalance gets updated
  }

  useEffect(() => {
    fetchUpcomingAppointments();
    fetchNextPaymentDate();
  }, [])

  return (
    <>
      <Box mb={2}>
        <Box mb={2}>
          <Typography variant="h4">Jouw afspraken</Typography>
          <Typography variant="body1">
            Hieronder zie je een overzicht van de projecten waarvoor je jezelf hebt aangemeld of een afspraak hebt gemaakt.
          </Typography>
        </Box>

        <Box mb={2} sx={{maxWidth: '400px'}}>
          <UpcomingAppointmentsList appointments={upcomingAppointments} onCancelSuccess={fetchUpcomingAppointments} />
        </Box>

        <Box mb={2}>
          <Link to={"/projecten"}>
            <Button color="secondary" variant="outlined" href="/projecten">Bekijk beschikbare projecten</Button>
          </Link>
        </Box>
      </Box>

      <Box>
        <Typography variant="h4" gutterBottom>Uitbetaling</Typography>
        <Typography variant="body1" gutterBottom>
          De volgende uitbetaling staat gepland voor <b>{nextPaymentDate ? format(nextPaymentDate, 'd MMMM yyyy') : <Skeleton variant="text" sx={{ display: 'inline-block', width: '60px'}}/>}</b>.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Uw saldo is <Link to={"/account/saldo"}>{myUser ? formatPrice(myUser.accountBalance) : <Skeleton variant="text" sx={{ display: 'inline-block', width: '60px'}}/>}</Link>
        </Typography>
      </Box>

      <Box mb={4}>
        {!myUser && <Skeleton><PayoutForm /></Skeleton>}
        {myUser && <PayoutForm onSuccess={onPayoutSuccess} ibanVerified={myUser.ibanVerified} />}
      </Box>
    </>
  );
}

export default DashboardPage;

DashboardPage.propTypes = {};

DashboardPage.defaultProps = {};
